import RadioCircle from '../RadioCircle/RadioCircle'
import { toCurrencyFormat } from '@jagad/utils'
import {
  OuterContainer,
  InnerContainer,
  PhoneNumber,
  RightSection,
  FreePriceTag,
  PriceText,
  PriceBold
} from './PhoneNumberOption.styles'

type PriceProps = {
  price: number | 'free'
  freeLabel: string
}

const Price = ({ price, freeLabel }: PriceProps) => {
  if (price === 0 || price === 'free') {
    return <FreePriceTag>{freeLabel}</FreePriceTag>
  } else {
    return (
      <PriceText>
        {'JIDR '}
        <PriceBold>{toCurrencyFormat(price)}</PriceBold>
      </PriceText>
    )
  }
}

export type PhoneNumberOptionProps = {
  number: string
  selected?: boolean
  price: number | 'free'
  freeLabel: string
}

export default function PhoneNumberOption({ number, selected, price, freeLabel }: PhoneNumberOptionProps) {
  return (
    <OuterContainer $selected={selected}>
      <InnerContainer $selected={selected}>
        <PhoneNumber>{number}</PhoneNumber>
        <RightSection>
          <Price price={price} freeLabel={freeLabel} />
          <RadioCircle checked={selected} />
        </RightSection>
      </InnerContainer>
    </OuterContainer>
  )
}
